const preproduction = {
  env: 'preproduction',
  backendUrl: 'https://api-surveys.pre.antevenio.com',
}
export default preproduction
